import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfileService } from '../services/profile/profile.service';
import { LocalizationService } from '../services/localization/localization.service';

@Injectable({
  providedIn: 'root'
})
export class HasSubscriptionGuard implements CanActivate {
  constructor(
    private localizationService: LocalizationService,
    private profileService: ProfileService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.profileService.userActiveSubscriptions().pipe(
      map(subs => {
        let hasActiveSubscription: boolean = false;
        let hasPastDueSubscription: boolean = false;
        let hasIncompleteSubscription: boolean = false;

        if (!!subs && subs.length > 0) {
          if (subs.some(sub => sub.status === 'active')) {
            hasActiveSubscription = true;
          }

          if (subs.some(sub => sub.status === 'past_due')) {
            hasPastDueSubscription = true;
          }

          if (subs.some(sub => sub.status === 'incomplete')) {
            hasPastDueSubscription = true;
          }
        }

        if (hasActiveSubscription) {
          this.localizationService.navigate(['profile']);
        }

        if (hasPastDueSubscription || hasIncompleteSubscription) {
          this.localizationService.navigate(['settings']);
        }

        const canActivateCheck =
          hasActiveSubscription ||
          hasPastDueSubscription ||
          hasIncompleteSubscription;

        return !canActivateCheck;
      })
    );
  }
}
